import { _axios } from '@/plugins/axios';

const SocResource = '/api/v1/soc';

export default {
  all: () => _axios.get(`${SocResource}/all`),
  create: SocName => _axios.post(`${SocResource}/create`, SocName),
  getById: id => _axios.get(`${SocResource}/${id}`),
  getRequirements: id => _axios.get(`${SocResource}/${id}/requirements`),
  update: updatedData => _axios.put(`${SocResource}/update/`, updatedData),
  deleteById: id => _axios.delete(`${SocResource}/delete/${id}`),
  checkDuplicateName: name =>
    _axios.get(`${SocResource}/check-duplicate-name/${encodeURIComponent(name)}`),
};
